/**
 * Формат почты. Проверка намеренно грубая: единственная её задача — не
 * отправлять на сервер заведомый мусор («aaa», «a@b»), а окончательное решение
 * всё равно за бэком. Zod в проекте нет, и ради одной строки его не заводим.
 *
 * Регулярка — та же, что уже стояла инлайном на экране входа: копий этого
 * условия в репозитории должно быть НОЛЬ, иначе два места начнут расходиться в
 * том, что считать почтой.
 */
export const isValidEmail = (value: string): boolean => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
